import { memo } from "react";

import { type ThemeMode } from "@root/tablescape/state";

type Props = {
  locale: string;
  price: number;
  theme: ThemeMode;
};
const KlarnaViewBase = ({ locale, price, theme }: Props) => {
  return (
    <klarna-placement
      data-key="credit-promotion-auto-size"
      data-locale={locale}
      data-purchase-amount={price}
      id={`klarna-placement-${theme}`}
    />
  );
};

export const KlarnaView = memo(KlarnaViewBase);
